import * as svg from "../../../assets/hamburger-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const HamburgerIcon = iconBuilder(svg, "HamburgerIcon", "0 0 20 20");
